import FooterWithProviders from './Footer'

import './locales'

const Footer = FooterWithProviders

export default Footer
export { FooterWithProviders }
export { default as CookiePreferences } from './components/CookiePreferences'
export { default as CFFooter } from './CFFooter/CFFooter'
